var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"prescription-card"},[_c('h2',{staticClass:"section-title"},[_c('span',{staticClass:"title-accent"}),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }